import { useState } from "react";
import axios from "axios";
import { deleteUser, sendQuestion } from "../services/quaService";

export default function UserQna() {
    const [activeSection, setActiveSection] = useState(null);
    const [deleteForm, setDeleteForm] = useState({ username: "", name: "", birth: "" });
    const [questionText, setQuestionText] = useState("");

    const toggleSection = (section) => {
        setActiveSection(prev => (prev === section ? null : section));
    };

    const handleDeleteSubmit = async () => {
        try {
            const res = await deleteUser(deleteForm);
            alert(res.message);
        } catch (error) {
            alert(error.response?.data?.message || "삭제 요청 실패");
        }
    };

    const handleQnaSubmit = async () => {
        try {
            const res = await sendQuestion(questionText);
            alert(res.message);
        } catch (error) {
            alert(error.response?.data?.message || "문의 요청 실패");
        }
    };
    return (
        <div className='user_qna'>
            <p className="title"><img src="/media/logo.png" alt="곡성 스마트 안전지도" /></p>
            <h2>문의사항</h2>

            {/* 사용자 삭제 섹션 */}
            <div className="qna_wrp">
                <p className="tit" onClick={() => toggleSection("deleteUser")} style={{ cursor: 'pointer' }}>
                    사용자 삭제
                </p>
                {activeSection === "deleteUser" && (
                    <div className="content">
                        <input type="text" placeholder="아이디" value={deleteForm.username}
                            onChange={e => setDeleteForm({ ...deleteForm, username: e.target.value })} />
                        <input type="text" placeholder="사용자 이름" value={deleteForm.name}
                            onChange={e => setDeleteForm({ ...deleteForm, name: e.target.value })} />
                        <input type="text" placeholder="사용자 생년월일" value={deleteForm.birth}
                            onChange={e => setDeleteForm({ ...deleteForm, birth: e.target.value })} />
                        <button onClick={handleDeleteSubmit}>확인</button>
                    </div>
                )}
            </div>

            {/* 문의하기 섹션 */}
            <div className="qna_wrp">
                <p className="tit" onClick={() => toggleSection("askQuestion")} style={{ cursor: 'pointer' }}>
                    문의하기
                </p>
                {activeSection === "askQuestion" && (
                    <div className="content">
                        <textarea placeholder="문의 내용을 입력하세요." value={questionText}
                            onChange={e => setQuestionText(e.target.value)} />
                        <button onClick={handleQnaSubmit}>확인</button>
                    </div>
                )}
            </div>
        </div>
    );
}
